import { render, staticRenderFns } from "./CommentConfirmCommentListModal.vue?vue&type=template&id=6e3b5d77&"
import script from "./CommentConfirmCommentListModal.vue?vue&type=script&lang=ts&"
export * from "./CommentConfirmCommentListModal.vue?vue&type=script&lang=ts&"
import style0 from "./CommentConfirmCommentListModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports